const getters = {
    basketItemsCount(state) {
        if (state.basketState) {
            return state.basket && state.basket.items && state.basket.items.length;
        }

        return null;
    }
};

export default getters;